import * as React from 'react';
import { Body1, Link } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './style.css';
import { getNewbuildingIdFromUrl } from '../shared/getNewbuildingIdFromUrl';
import { trackNavigationToListingJK } from '../shared/tracking';
import { IRoomStatsCell } from '../../../../../../types/newbuildingsCompare';

export interface IRoomStatsCellProps {
  cell: IRoomStatsCell;
}

export const RoomStatsCell = ({ cell }: IRoomStatsCellProps): React.JSX.Element => {
  const { data } = cell;

  const handleLinkClick = React.useCallback(() => {
    if (data) {
      trackNavigationToListingJK(getNewbuildingIdFromUrl(data.roomLink.url));
    }
  }, [data]);

  if (!data) {
    return (
      <div className={style['container']}>
        <Body1 color="text-secondary-default">{cell.state.text}</Body1>
      </div>
    );
  }

  return (
    <div className={style['container']}>
      {data.priceRange && <Body1>{data.priceRange}</Body1>}
      {data.minArea && <Body1 color="text-secondary-default">{data.minArea}</Body1>}
      <Link
        href={data.roomLink.url}
        target="_blank"
        fontSize="M"
        fontWeight="bold"
        onClick={handleLinkClick}
        afterIcon={<IconActionChevronRightSmall16 color="icon-main-default" />}
      >
        {data.roomLink.text}
      </Link>
    </div>
  );
};
